import Skeleton from "react-loading-skeleton";
import { useMediaQuery } from "react-responsive";
import { isDesktopMediaQuery } from "../constants/constants";

const CampaignSkeleton: React.FC = () => {
    const isDesktop = useMediaQuery(isDesktopMediaQuery)
    return (
        <div className="card card-style">
            <Skeleton className="card card-style mx-3 my-3 rounded-4" style={{height: isDesktop ? '280px' : '180px', width: isDesktop ? '95%': '91%'}} />
            <Skeleton className="m-3 mt-1 rounded-4" style={{height: '35px', width: isDesktop ? '95%': '91%'}} />
        </div>
    )
}
export default CampaignSkeleton;